import { NestedModel, util } from '@glu/core';

export default class extends NestedModel {
  // TODO can be removed when Glu updates to next version of Backbone
  isEmpty() {
    return util.isEmpty(this.toJSON());
  }

  setSelected(selected) {
    this.set('selected', selected, {
      // to prevent view re-rendering
      silent: true
    });
  }

  // extend model destroy to always use wait flag
  destroy(options = {}) {
    return super.destroy({
      ...options,
      // Should wait for the response and then remove the item
      wait: true
    });
  }

  hasError() {
    return !util.isEmpty(this.get('error'));
  }

  save(attrs, options = { success: undefined, error: undefined }) {
    return super.save(attrs, {
      ...options,
      success: options.success,
      error: (model, xhr, opts) => {
        // added this one due to backend response not contains 'error' but contains 'errors'
        if (xhr.responseJSON && xhr.responseJSON.errors) {
          this.set(this.parse(xhr.responseJSON));
        } else if (xhr.responseText) {
          this.set('error', {
            generic: [xhr.responseText]
          });
        }
        model.trigger('invalid');

        if (options.error) {
          options.error(model, xhr, opts);
        }
      }
    });
  }

  parse(resp) {
    if (this.collection) {
      return resp;
    }

    const newResp = { ...resp };

    if (newResp.errors) {
      Object.assign(newResp, { error: resp.errors });
    }

    return super.parse(util.omit(newResp, ['errors']));
  }
}